
  import { Component, Vue, Prop, Watch } from "vue-property-decorator";

  @Component
  export default class ClubModal extends Vue {
    @Prop({ required: true, default: false }) public readonly modalShow!: boolean;
   
    public isModalClosed: boolean = false;
    public loading: boolean = false;

    public async mounted() {
      localStorage.setItem("welcomeResidentModalShown", "true");
    }
    // Methods
    public closeModal() {
      this.isModalClosed = true;      
      this.$emit("close-modal");
    }
  }
  